module.exports = __webpack_public_path__ + "static/media/users_second.2b8030a7.svg";